import {
  Container,
  Card,
  SuccessIcon,
  ButtonLogin,
  EmailBox,
  LogoCanto,
} from "./styles.js";
import logoCanto from "../../assets/logoCanto.png";

import { useLocation, useHistory } from "react-router-dom";
import ls from "../../services/localStorage";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIdCard, faUserShield } from "@fortawesome/free-solid-svg-icons";

function BiometricAlert() {
  const location = useLocation();
  const history = useHistory();

  // 1️⃣ URL via state

  const urlFromState = location.state?.url;

  // 3️⃣ URL via localStorage
  const urlFromStorage = ls().get("url");

  // URL final (prioridade)
  const redirectUrl = urlFromState || urlFromStorage;
  const handleContinue = () => {
    if (redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      history.replace("/register-resident");
    }
  };

  return (
    <>
      <Container>
        <Card>
          <LogoCanto src={logoCanto} alt="Logo Cantoneira" />
          <SuccessIcon>
            <FontAwesomeIcon icon={faUserShield} />
          </SuccessIcon>

          <h1>Validação por Biometria</h1>

          <p className="note" style={{ marginTop: "15px" }}>
            Para dar continuidade ao processo, será realizada uma{" "}
            <strong>biometria</strong> com o objetivo de validar as informações
            fornecidas durante a inscrição.
          </p>

          <EmailBox>
            <FontAwesomeIcon icon={faIdCard} />
            <span>
              É obrigatório ter em mãos um{" "}
              <strong>documento físico e oficial com foto</strong> <br />
            </span>
            <strong>RG ou CNH</strong>
          </EmailBox>

          <p className="note">
            Certifique-se de estar em um ambiente bem iluminado e com o
            documento legível para seguir com a biometria.
          </p>

          <ButtonLogin type="button" onClick={handleContinue}>
            Continuar
          </ButtonLogin>
        </Card>
      </Container>
    </>
  );
}

export default BiometricAlert;
